import { apiClient } from "../../apiClient";
import { DashboardData, DashboardParams } from "./type";

export const dashboardService = {
  getDashboardData: async (
    params?: DashboardParams,
  ): Promise<DashboardData> => {
    const queryParams = new URLSearchParams();

    if (params?.startDate) queryParams.append("startDate", params.startDate);
    if (params?.endDate) queryParams.append("endDate", params.endDate);
    if (params?.range) queryParams.append("range", params.range);

    const response = await apiClient.get<DashboardData>(
      `/dashboard?${queryParams.toString()}`,
    );
    return response.data;
  },

  getCashFlowData: async (params?: DashboardParams) => {
    const queryParams = new URLSearchParams();

    if (params?.startDate) queryParams.append("startDate", params.startDate);
    if (params?.endDate) queryParams.append("endDate", params.endDate);
    if (params?.range) queryParams.append("range", params.range);

    const response = await apiClient.get(
      `/dashboard/cash-flow?${queryParams.toString()}`,
    );
    return response.data;
  },

  getExpenseBreakdown: async (params?: DashboardParams) => {
    const queryParams = new URLSearchParams();

    if (params?.startDate) queryParams.append("startDate", params.startDate);
    if (params?.endDate) queryParams.append("endDate", params.endDate);
    if (params?.range) queryParams.append("range", params.range);

    const response = await apiClient.get(
      `/dashboard/expense-breakdown?${queryParams.toString()}`,
    );
    return response.data;
  },
};
